export class ArquivoRequest {
  public idArquivo: number | null;
  public nome: string;
  public versao: string;
  public idCategoriaArquivo: number;
  public localArquivo: string;
  public urlArquivoGCP: string;
  public idTagArquivo: number;
}
